<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-20">
      <!-- begin col-8 -->
      <div class="col-sm-12">
        <!-- begin widget-chart -->
        <div
          class="widget widget-rounded m-b-30"
          v-bind:class="{ 'inverse-mode': inverseMode }"
        >
          <div class="card-body" style="padding: 5px 10px">
            <div class="ts-flex ts-justify-between">
              <div
                class="ts-flex ts-justify-content-start"
                :class="{ 'ts-text-gray-700': !inverseMode }"
              >
                <strong>
                  CASH COLLECTION BY CASHIER & TOP 10 FAST PRODUCTS SOLD
                </strong>
                <span class="ml-2"
                  ><i
                    class="fa fa-info-circle"
                    title="Top products with units sold"
                    v-b-popover.hover="
                      'Products with the most individual units sold. Includes orders from all sales channels.'
                    "
                  ></i
                ></span>
              </div>
              <div class="ts-flex ts-justify-content-end">
                <select
                  v-model="branch_id"
                  @change="fetchData"
                  style="width: 150px"
                  class="filter mr-2"
                  :class="{ 'filter-dark': inverseMode }"
                >
                  <option value>--Select Branch--</option>
                  <option
                    v-for="(branch, key) in branches"
                    :value="branch.branch_id"
                    :key="key"
                  >
                    {{ branch.branch_name_en }}
                  </option>
                </select>
                <a-range-picker
                  style="width: 300px"
                  v-model="rangeDate"
                  :ranges="{
                    Today: [moment(), moment()],
                    'This Month': [
                      moment().startOf('month'),
                      moment().endOf('month')
                    ]
                  }"
                  format="DD-MM-YYYY"
                />
              </div>
            </div>
          </div>
          <!-- begin vertical-box -->
          <ts-loading-banner :loading="loading">
            <div class="vertical-box with-grid with-border-top">
              <!-- begin vertical-box-column -->
              <div class="vertical-box-column widget-chart-content">
                <div class="nv-stacked-area-chart height-full">
                  <p class="p-2">
                    Stacked area charts shows the quantities of the total sale
                    items based on the selected period of dates by branch or
                    company.
                  </p>
                  <vn-stacked-area
                    :model="datasets"
                    yFormat=",.2f"
                    :xFormat="formatDate"
                    :clipEdge="stackedAreaChart.clipEdge"
                    :rightAlignYAxis="stackedAreaChart.rightAlignYAxis"
                    :showControls="stackedAreaChart.showControls"
                    style="min-height: 355px; height: 329px"
                  ></vn-stacked-area>
                </div>
              </div>
              <!-- end vertical-box-column -->
              <!-- begin vertical-box-column -->
              <div
                class="vertical-box-column"
                style="width: 50%; text-align: right"
              >
                <p class="p-2">
                  Polar area charts shows the top ten sale items based on the
                  selected categories.
                </p>
                <vn-hbar
                  :model="multiBarHorizontalChart.data"
                  y-format=".0f"
                  :showControls="areaChart.showControls"
                >
                </vn-hbar>
              </div>
              <!-- end vertical-box-column -->
            </div>
          </ts-loading-banner>
          <!-- end vertical-box -->
        </div>
        <!-- end widget-chart -->
      </div>
      <!-- end col-8 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import moment from 'moment'
import { map } from 'lodash'
import { mapActions } from 'vuex'
export default {
  props: ['inverseMode'],
  data () {
    return {
      loading: false,
      branch_id: '',
      rangeDate: [
        moment()
          .add(-3, 'Month')
          .startOf('month'),
        moment().endOf('month')
      ],
      // stacked Area Chart
      cashCollectionByCashier: [],
      stackedAreaChart: {
        rightAlignYAxis: false,
        showControls: false,
        clipEdge: false,
        height: '350px'
      },
      color: [
        '#5AC8FA',
        '#348fe2',
        '#ffc107',
        '#b6c2c9',
        '#00acac',
        '#2d353c',
        '#ff5b57',
        '#6610f2',
        '#fd7e14',
        '#e83e8c'
      ],
      // polar Area Chart
      saleItemsTop10: [],
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      areaChart: {
        rightAlignYAxis: false,
        showControls: false,
        clipEdge: false
      }
    }
  },
  computed: {
    branches () {
      return this.$store.state.dashboard.widget.branches
    },
    multiBarHorizontalChart () {
      return {
        data: [
          {
            key: 'Quantity',
            color: '#00acac',
            values: map(this.saleItemsTop10, (item, key) => {
              return {
                label: key,
                value: item.quantity
              }
            })
          }
        ]
      }
    },
    // vn-stacked-area chart
    datasets () {
      return map(this.cashCollectionByCashier, (items, key) => {
        return {
          key: key,
          color: this.generator(),
          values: map(items, (item, key) => {
            return {
              x: new Date(key).getTime(),
              y: item.sale_amount
            }
          })
        }
      })
    }
  },
  methods: {
    ...mapActions('dashboard/widget', ['getBranch']),
    moment,
    generator () {
      return this.color[Math.floor(Math.random() * this.color.length)]
    },
    async fetchData () {
      this.cashCollectionByCashier = []
      this.saleItemsTop10 = []
      this.loading = true
      await this.getBranch()
      await this.$store
        .dispatch('dashboard/widget/fetchCashCollectionByCashier', {
          branch_id: this.branch_id,
          date_from: this.rangeDate[0].format('DD-MM-YYYY'),
          date_to: this.rangeDate[1].format('DD-MM-YYYY')
        })
        .then(responses => {
          this.cashCollectionByCashier = responses
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
      this.$store
        .dispatch('dashboard/widget/fetchTop10FastProductSold', {
          branch_id: this.branch_id,
          date_from: this.rangeDate[0].format('DD-MM-YYYY'),
          date_to: this.rangeDate[1].format('DD-MM-YYYY')
        })
        .then(responses => {
          for (var propName in responses) {
            if (responses.hasOwnProperty(propName)) {
              this.saleItemsTop10 = responses[propName]
            }
          }
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    formatDate (d) {
      // eslint-disable-next-line
      return d3.time.format('%x')(new Date(d))
    }
  },
  watch: {
    rangeDate: function () {
      this.fetchData()
    }
  }
}
</script>
<style scoped>
.nvd3-svg {
  width: 100% !important;
}
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.widget-header-title,
.widget-header-icon {
  padding: 5px 10px !important;
}
</style>
